// extracted by mini-css-extract-plugin
export default {"tags":"contextTags_tags__7TxqS","tag":"contextTags_tag__6nuEB"};